/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Localised Airport record
 * @export
 * @interface PaxCheckAirport
 */
export interface PaxCheckAirport {
    /**
     * Airport name
     * @type {string}
     * @memberof PaxCheckAirport
     */
    airportName: string;
    /**
     * Airport IATA code
     * @type {string}
     * @memberof PaxCheckAirport
     */
    airportCode: string;
    /**
     * City name
     * @type {string}
     * @memberof PaxCheckAirport
     */
    cityName: string;
}

/**
 * Check if a given object implements the PaxCheckAirport interface.
 */
export function instanceOfPaxCheckAirport(value: object): value is PaxCheckAirport {
    if (!('airportName' in value) || value['airportName'] === undefined) return false;
    if (!('airportCode' in value) || value['airportCode'] === undefined) return false;
    if (!('cityName' in value) || value['cityName'] === undefined) return false;
    return true;
}

export function PaxCheckAirportFromJSON(json: any): PaxCheckAirport {
    return PaxCheckAirportFromJSONTyped(json, false);
}

export function PaxCheckAirportFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAirport {
    if (json == null) {
        return json;
    }
    return {
        
        'airportName': json['airport_name'],
        'airportCode': json['airport_code'],
        'cityName': json['city_name'],
    };
}

export function PaxCheckAirportToJSON(json: any): PaxCheckAirport {
    return PaxCheckAirportToJSONTyped(json, false);
}

export function PaxCheckAirportToJSONTyped(value?: PaxCheckAirport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airport_name': value['airportName'],
        'airport_code': value['airportCode'],
        'city_name': value['cityName'],
    };
}

